import axiosInstance from "../../../Hooks/axoisInstance";
import { API_BASE_URL1 } from "../../Services/baseApiUrl";

const getToken = () => {
    return localStorage.getItem("token");
};




export const GetActiveDepartments = async () => {
    try {
        const response = await axiosInstance.get(`${API_BASE_URL1}Attendance/GetAllActiveDepartments`,
            {
                headers: {
                    Authorization: `Bearer ${getToken()}`
                }
            }
        );
      
        return response;
    } catch (error) {
        return error;
    }
};

// ─── Designation APIs ────────────────────────────────────────────────────────
// Both add and update use the SAME endpoint: Attendance/AddAndUpdateDesignation
// The API distinguishes between insert vs update by the presence of `designationId`.
//   - Add:    no designationId in payload  → backend inserts
//   - Update: designationId present        → backend updates

export const addDesignation = async (payload) => {
    try {
        // payload shape: { departmentId, designationName, isActive }
        const response = await axiosInstance.post(
            `${API_BASE_URL1}Attendance/AddAndUpdateDesignation`,
            payload,
            {
                headers: {
                    Authorization: `Bearer ${getToken()}`,
                },
            }
        );
        return response;
    } catch (error) {
        return error;
    }
};

export const updateDesignation = async (payload) => {
    try {
        // payload shape: { designationId, departmentId, designationName, isActive }
        const response = await axiosInstance.post(
            `${API_BASE_URL1}Attendance/AddAndUpdateDesignation`,
            payload,
            {
                headers: {
                    Authorization: `Bearer ${getToken()}`,
                },
            }
        );
        return response;
        console.log("Update Designation Response:", response);
    } catch (error) {
        return error;
    }
};

export const GetDesignations = async (DesignationName = "", departmentId = "", IsActive = "") => {
    try {
        const params = {};

        if (DesignationName) params.DesignationName = DesignationName;   // ✅ swagger param
        if (departmentId) params.DepartmentId = departmentId;
        if (IsActive !== "") params.IsActive = IsActive;

        const response = await axiosInstance.get(
            `${API_BASE_URL1}Attendance/GetAllDesignation`,
            {
                headers: {
                    Authorization: `Bearer ${getToken()}`,
                },
                params,  // ✅ builds ?DesignationName=super automatically
            }
        );
        return response.data;
        console.log("Designations fetched with filters:", params, "Response:", response.data);
        console.log("Full Api Data", response);
    } catch (error) {
        return error;
    }
};

export const GetIdentityTypes = async () => {
    try {
        const response = await axiosInstance.get(`${API_BASE_URL1}Attendance/GetIdentityTypes`,
            {
                headers: {
                    Authorization: `Bearer ${getToken()}`
                }
            }
        );
        return response.data;
    } catch (error) {
        return error;
    }
};

export const GetEmployeeTypes = async () => {
    try {
        const response = await axiosInstance.get(`${API_BASE_URL1}Attendance/GetEmployeeTypes`,
            {
                headers: {
                    Authorization: `Bearer ${getToken()}`
                }
            }
        );
        return response.data.data;
    } catch (error) {
        return error;
    }
};

export const GetKPICategories = async () => {
    try {
        const response = await axiosInstance.get(`${API_BASE_URL1}Attendance/GetKPIDetails`,
            {
                headers: {
                    Authorization: `Bearer ${getToken()}`
                }
            }
        );
        return response.data;
        console.log("KPI Categories:", response.data);
    } catch (error) {
        return error;
    }
};


export const GetEmployees = async (filters) => {
    const { ZoneId, CircleId, IsActive } = filters;
    try {
        const response = await axiosInstance.get(`${API_BASE_URL1}Attendance/GetAllEmployees?ZoneId=${ZoneId}&CircleId=${CircleId}&IsActive=${IsActive}`,
            {
                headers: {
                    Authorization: `Bearer ${getToken()}`,
                    "Content-Type": "application/json",
                }
            }
        );
        return response.data;
        console.log("Employees fetched with filters:", filters, "Response:", response.data);
        console.log("Full Api Data", response);
    } catch (error) {
        return error;
    }
};

export const AddNewEmployee = async (responseData) => {
    try {
        const response = await axiosInstance.post(`${API_BASE_URL1}Attendance/AddEmployee`, responseData,
            {
                headers: {
                    Authorization: `Bearer ${getToken()}`,
                    "Content-Type": "multipart/form-data",
                }
            }
        );
        return response;
    } catch (error) {
        return error;
    }
};

export const EditEmployeeDetails = async (responseData) => {
    try {
        const response = await axiosInstance.put(`${API_BASE_URL1}Attendance/UpdateEmployeeDetails`, responseData,
            {
                headers: {
                    Authorization: `Bearer ${getToken()}`,
                    "Content-Type": "multipart/form-data",
                }
            }
        );
        return response;
    } catch (error) {
        return error;
    }
};


export const getActiveDepartment = async (OperationId, IsActive) => {
    try {
        const params = {};
        if (OperationId)            params.OperationId = OperationId;
        if (IsActive !== undefined) params.IsActive = IsActive;

        const response = await axiosInstance.get(
            `${API_BASE_URL1}Attendance/GetAllActiveDepartments`,  // ✅ correct endpoint
            {
                headers: { Authorization: `Bearer ${getToken()}` },
                params,
            }
        );
        return response;
    } catch (error) {
        return error;
    }
};
export const GetCircleByZoneId = async (zoneId) => {
    try {
        const response = await axiosInstance.get(
            `${API_BASE_URL1}Attendance/GetCircleByZoneId/${zoneId}`,
            {
                headers: { Authorization: `Bearer ${getToken()}` },
            }
        );
        return response.data;
    } catch (error) {
        return error;
    }
};

// export const addDesignation = async (values) => {
//     try {
//         const response = await axiosInstance.post(`${API_BASE_URL1}Attendance/AddAndUpdateDepartment`, values,
//             {
//                 headers: {
//                     Authorization: `Bearer ${getToken()}`,
//                 }
//             }
//         );
//         return response;
//     } catch (error) {
//         return error;
//     }
// };


// export const updateDesignation = async (values) => {
//     try {
//         const response = await axiosInstance.put(`${API_BASE_URL1}GMAM/Attendance/UpdateDesignationDetails`, values,
//             {
//                 headers: {
//                     Authorization: `Bearer ${getToken()}`,
//                 }
//             }
//         );
//         return response;
//     } catch (error) {
//         return error;
//     }
// };

export const GetOperations = async (IsActive = "") => {
    try {
        const response = await axiosInstance.get(`${API_BASE_URL1}GMAM/Attendance/GetOperations?IsActive=${IsActive}`, {
            headers: {
                Authorization: `Bearer ${getToken()}`
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching operations:', error);
        return error;
    }
};
export const GetVehicleType = async (IsActive = "") => {
    try {
        const response = await axiosInstance.get(`${API_BASE_URL1}Attendance/GetVehicleType`, {
            headers: {
                Authorization: `Bearer ${getToken()}`
            }
        });
        return response.data.data;
    } catch (error) {
        console.error('Error fetching vehicle types:', error);
        return error;
    }
}
// API call to add a new operation (POST request)
export const AddOperationDetails = async (data) => {
    try {
        const response = await axiosInstance.post(
            `${API_BASE_URL1}GMAM/Attendance/AddNewOperation`,
            data,
            {
                headers: {
                    Authorization: `Bearer ${getToken()}`,
                    "Content-Type": "application/json",
                },
            }
        );
        return response;
    } catch (error) {
        console.error('Error adding operation:', error);
        return error;
    }
};
// API call to update an operation (PUT request)
export const UpdateOperationDetails = async (data) => {
    try {
        const response = await axiosInstance.put(
            `${API_BASE_URL1}GMAM/Attendance/UpdateOperationDetails`,
            data,
            {
                headers: {
                    Authorization: `Bearer ${getToken()}`,
                    "Content-Type": "application/json",
                },
            }
        );
        return response;
    } catch (error) {
        console.error("Error updating operation:", error);
        return error;
    }
};


// ─── Attendance Management APIs ──────────────────────────────────────────────

export const GetAttendanceZones = async () => {
    try {
        // Some parts of the app call `GetAllZone` (singular) while others call
        // `GetAllZones` (plural). Try the singular endpoint first, then
        // fall back to the plural one to be tolerant of backend differences.
        try {
            const resp1 = await axiosInstance.get(
                `${API_BASE_URL1}MasterDetails/GetAllZone`,
                { headers: { Authorization: `Bearer ${getToken()}` } }
            );
            // If we get a successful response with data, return it
            if (resp1 && (Array.isArray(resp1.data) || resp1.data)) return resp1.data;
        } catch (e) {
            // ignore and try fallback
        }

        const response = await axiosInstance.get(
            `${API_BASE_URL1}MasterDetails/GetAllZones`,
            { headers: { Authorization: `Bearer ${getToken()}` } }
        );
        return response.data;
    } catch (error) {
        return error;
    }
};

export const GetAttendanceWards = async () => {
    try {
        const response = await axiosInstance.get(
            `${API_BASE_URL1}Attendance/GetAllWards`,
            { headers: { Authorization: `Bearer ${getToken()}` } }
        );
        return response.data;
    } catch (error) {
        return error;
    }
};

export const GetAttendanceEmployees = async () => {
    try {
        const response = await axiosInstance.get(
            `${API_BASE_URL1}Attendance/GetAllEmployees`,
            { headers: { Authorization: `Bearer ${getToken()}` } }
        );
        return response.data;
    } catch (error) {
        return error;
    }
};

export const GetAttendanceShifts = async () => {
    try {
        const response = await axiosInstance.get(
            `${API_BASE_URL1}Attendance/GetAllShifts`,
            { headers: { Authorization: `Bearer ${getToken()}` } }
        );
        return response.data;
    } catch (error) {
        return error;
    }
};

export const GetAttendanceDesignations = async () => {
    try {
        const response = await axiosInstance.get(
            `${API_BASE_URL1}Attendance/GetAllDesignation`,
            { headers: { Authorization: `Bearer ${getToken()}` } }
        );
        return response.data;
    } catch (error) {
        return error;
    }
};

export const GetAllAttendance = async (filters = {}) => {
    try {
        const response = await axiosInstance.get(
            `${API_BASE_URL1}Attendance/GetAllAttendance`,
            {
                headers: { Authorization: `Bearer ${getToken()}` },
                params: filters,
            }
        );
        return response.data;
    } catch (error) {
        return error;
    }
};

export const AddAttendance = async (payload) => {
    try {
        const response = await axiosInstance.post(
            `${API_BASE_URL1}Attendance/AddAttendance`,
            payload,
            { headers: { Authorization: `Bearer ${getToken()}` } }
        );
        return response;
    } catch (error) {
        return error;
    }
};

export const UpdateAttendance = async (payload) => {
    try {
        const response = await axiosInstance.put(
            `${API_BASE_URL1}Attendance/UpdateAttendance`,
            payload,
            { headers: { Authorization: `Bearer ${getToken()}` } }
        );
        return response;
    } catch (error) {
        return error;
    }
};

export const DeleteAttendance = async (attendanceId) => {
    try {
        const response = await axiosInstance.delete(
            `${API_BASE_URL1}Attendance/DeleteAttendance`,
            {
                headers: { Authorization: `Bearer ${getToken()}` },
                params: { AttendanceId: attendanceId },
            }
        );
        return response;
    } catch (error) {
        return error;
    }
};

export const ExportAttendanceExcel = async (filters = {}) => {
    try {
        const response = await axiosInstance.get(
            `${API_BASE_URL1}Attendance/ExportAttendanceExcel`,
            {
                headers: { Authorization: `Bearer ${getToken()}` },
                params: filters,
                responseType: "blob",
            }
        );
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "Attendance.xlsx");
        document.body.appendChild(link);
        link.click();
        link.remove();
        return response;
    } catch (error) {
        return error;
    }
};

export const ExportAttendancePDF = async (filters = {}) => {
    try {
        const response = await axiosInstance.get(
            `${API_BASE_URL1}Attendance/ExportAttendancePDF`,
            {
                headers: { Authorization: `Bearer ${getToken()}` },
                params: filters,
                responseType: "blob",
            }
        );
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "Attendance.pdf");
        document.body.appendChild(link);
        link.click();
        link.remove();
        return response;
    } catch (error) {
        return error;
    }
};

// ─── Ward / Employee helpers used by AddAttendanceModal ──────────────────────

// export const GetWardsByZone = async (zoneId) => {
//     try {
//         const response = await axiosInstance.get(
//             `${API_BASE_URL1}Attendance/GetCircleByZoneId`,
//             {
//                 headers: { Authorization: `Bearer ${getToken()}` },
//                 params: { ZoneId: zoneId },
//             }
//         );
//         return response.data;
//     } catch (error) {
//         return error;
//     }
// };

export const GetTodayPunchTime = async (employeeId) => {
    try {
        const response = await axiosInstance.post(
            `${API_BASE_URL1}Attendance/today-punch-time`,
            { employeeId },
            { headers: { Authorization: `Bearer ${getToken()}` } }
        );
        return response.data;
    } catch (error) {
        return error;
    }
};

export const ManageAttendance = async (payload) => {
    try {
        const response = await axiosInstance.post(
            `${API_BASE_URL1}Attendance/manage-attendance`,
            payload,
            { headers: { Authorization: `Bearer ${getToken()}` } }
        );
        return response.data;
    } catch (error) {
        return error;
    }
};

export const EditAttendance = async (payload) => {
    try {
        const normalizedPayload = {
            ...payload,
            AttendanceId: payload.AttendanceId ?? payload.attendanceId,
            attendanceId: payload.attendanceId ?? payload.AttendanceId,
        };
        const response = await axiosInstance.put(
            `${API_BASE_URL1}Attendance/edit-attendance`,
            normalizedPayload,
            { headers: { Authorization: `Bearer ${getToken()}` } }
        );
        return response;
    } catch (error) {
        return error;
    }
};

export const DeleteAttendanceRecord = async (payload) => {
    try {
        const attendanceId = payload?.attendanceId ?? payload?.AttendanceId;
        const response = await axiosInstance.delete(
            `${API_BASE_URL1}Attendance/delete-attendance`,
            {
                headers: { Authorization: `Bearer ${getToken()}` },
                data: { AttendanceId: attendanceId, attendanceId },
            }
        );
        return response;
    } catch (error) {
        return error;
    }
};

export const GetWardsByZone = async (zoneId) => {
    try {
        const response = await axiosInstance.get(
            `${API_BASE_URL1}Attendance/GetCircleByZoneId/${zoneId}`,
            {
                headers: { Authorization: `Bearer ${getToken()}` },
            }
        );
        return response.data;
    } catch (error) {
        return error;
    }
};


export const ViewAttendance = async (filters = {}) => {
    try {
        const activeFilters = Object.fromEntries(
            Object.entries(filters).filter(([, value]) => value !== "" && value !== null && value !== undefined)
        );

        const payload = {
            ...activeFilters,
            PageNumber: 1,
            PageSize: 100,
        };

        return ManageAttendance(payload);
    } catch (error) {
        return error;
    }
};




// export const GetWardsByZone = async (zoneId) => {
//     try {
//         const response = await axiosInstance.get(
//             `${API_BASE_URL1}Attendance/GetCircleByZoneId/${zoneId}`, // ✅ zoneId in path
//             {
//                 headers: { Authorization: `Bearer ${getToken()}` },
//             }
//         );
//         return response.data;
//     } catch (error) {
//         return error;
//     }
// };

export const GetEmployeesByWard = async (wardId) => {
    try {
        const response = await axiosInstance.get(
            `${API_BASE_URL1}Attendance/GetEmployeesByWard`,
            {
                headers: { Authorization: `Bearer ${getToken()}` },
                params: { WardId: wardId },
            }
        );
        return response.data;
    } catch (error) {
        return error;
    }
};

// New: fetch active employees using zoneId/circleId params (lowercase keys)
export const GetActiveEmployees = async (zoneId, circleId) => {
    try {
        const params = {};
        if (zoneId !== undefined && zoneId !== null) params.zoneId = zoneId;
        if (circleId !== undefined && circleId !== null) params.circleId = circleId;
        params.isActive = true;

        const response = await axiosInstance.get(
            `${API_BASE_URL1}Attendance/GetAllEmployees`,
            {
                headers: { Authorization: `Bearer ${getToken()}` },
                params,
            }
        );
        return response.data;
    } catch (error) {
        return error;
    }
};